import DigitalBundlePhotoPreviewModal, {
  DIGITAL_BUNDLE_PHOTO_PREVIEW_MODAL,
} from './modal';

export { DIGITAL_BUNDLE_PHOTO_PREVIEW_MODAL };

export default DigitalBundlePhotoPreviewModal;
